import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginAction, otpValidate } from "../../store/actions/login"
import Form from 'react-bootstrap/Form';
import OtpInput from "react-otp-input";
import logo from "../../Assets/logo/logo_2x.svg";

window.envType = localStorage.getItem('envType') ? localStorage.getItem('envType') : 'DEV';

const ENV_OPTIONS = ['DEV', 'UAT', 'NEWGEN-UAT', 'PROD'];

const Login = () => {
    const [login, setLogin] = useState({
        userName: '',
        userType: "SUPPORT",
        envType: localStorage.getItem('envType') ? localStorage.getItem('envType') : 'DEV',
        otp: '',
        error: false
    });

    const user = useSelector(state => state.authentication);
    const dispatch = useDispatch();
    const envSelectRef = useRef(null);
    const [envMenuOpen, setEnvMenuOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (envSelectRef.current && !envSelectRef.current.contains(event.target)) {
                setEnvMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const inputLabel = login.userType === "SUPPORT" ? 'Mobile Number' : 'Agent Code';

    const handleEnvSelect = (value) => {
        inputHandler({ target: { value } }, 'env');
        setEnvMenuOpen(false);
    };

    const inputHandler = (e, type) => {
        if (type === "input") {
            setLogin({
                ...login,
                userName: e.target.value,
                error: false
            });
        } else if (type === "radio") {
            setLogin({
                ...login,
                userType: e.target.value,
                userName: '',
                error: false
            });
        } else {
            window.envType = e.target.value;
            setLogin({
                ...login,
                envType: e.target.value
            });
            localStorage.setItem('envType', e.target.value)
        }
    }

    const otphandler = (e) => {
        e.preventDefault();
        const loginCode = login.userName || (user.otpValues && user.otpValues.code)
        const actionText = e.target.innerText;
        if (loginCode) {
            if (actionText === "SEND OTP" || actionText === "Get OTP" || actionText === "Resend OTP") {
                dispatch(loginAction(loginCode, login.userType))
            } else {
                const data = {
                    code: loginCode,
                    referenceCode: user.otpValues.referenceNumber,
                    otp: login.otp
                }
                if (login.otp && login.otp.length > 5) {
                    dispatch(otpValidate(data, login.envType))
                } else {
                    setLogin({
                        ...login,
                        error: true
                    })
                }
            }
        }
    }

    const otpHandleChange = (otp) => {
        setLogin({
            ...login,
            otp: otp,
            error: false
        });
    }
console.log('login page>>>')
    return (
        <div className="login-page">
            <aside className="login-page__aside">
                <img src={logo} alt="Bharti AXA" className="login-page__aside-logo" />
                <h1 className="login-page__aside-title">Operations Panel</h1>
                <p className="login-page__aside-subtitle">Bharti AXA Life Insurance</p>
            </aside>

            <div className="login-page__content">
                <div className="loginForm">
                <img src={logo} alt="Bharti AXA" className="login-form-logo-mobile" />

                <div className="login-card-body">
                    {user.otpSent ? (
                        <form className="login-otp-form">
                            <h1 className="login-title">Login</h1>
                            <p className="login-subtitle">Enter your details to access your account</p>

                            <div className="otp-input-fields marginbottom">
                                <div className="label-wrapper">
                                    <label className="otp-input-label">Enter OTP</label>
                                </div>
                                <div className="otp-input-wrapper marginbottom">
                                    <OtpInput
                                        value={login.otp}
                                        onChange={otpHandleChange}
                                        numInputs={6}
                                        inputStyle="otp-field"
                                        hasErrored={false}
                                        errorStyle={false && "error"}
                                        isInputNum={true}
                                        shouldAutoFocus={true}
                                    />
                                </div>

                                <div onClick={otphandler} className="resendbt" name={user.otpSent ? "VERIFY OTP" : "SEND OTP"}>
                                    Resend OTP
                                </div>
                            </div>

                            {login.error && <div className="login-error">Please Enter OTP</div>}
                            <button type="button" onClick={otphandler} className="login-get-otp-btn">
                                VERIFY OTP
                            </button>
                        </form>
                    ) : (
                        <div className="login-credentials-form">
                            <h1 className="login-title">Login</h1>
                            <p className="login-subtitle">Enter your details to access your account</p>

                            <div className="login-env-select marginbottom">
                                <label id="loginEnvTypeLabel" className="login-field-label">Environment</label>
                                <div
                                    ref={envSelectRef}
                                    className={`login-select-wrapper ${envMenuOpen ? 'is-open' : ''}`}
                                >
                                    <button
                                        type="button"
                                        id="loginEnvType"
                                        className="login-select-field login-select-trigger"
                                        aria-haspopup="listbox"
                                        aria-expanded={envMenuOpen}
                                        aria-labelledby="loginEnvTypeLabel"
                                        onClick={() => setEnvMenuOpen((open) => !open)}
                                    >
                                        {login.envType}
                                    </button>
                                    {envMenuOpen && (
                                        <ul className="login-select-menu" role="listbox" aria-labelledby="loginEnvTypeLabel">
                                            {ENV_OPTIONS.map((option) => (
                                                <li
                                                    key={option}
                                                    role="option"
                                                    aria-selected={login.envType === option}
                                                    className={login.envType === option ? 'is-selected' : ''}
                                                    onClick={() => handleEnvSelect(option)}
                                                >
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <label className="login-field-label">User Type</label>
                            <div className="selectType marginbottom">
                                <Form.Check
                                    type="radio"
                                    label="SUPPORT"
                                    name="formHorizontalRadios"
                                    id="formHorizontalRadios1"
                                    value="SUPPORT"
                                    onChange={(e) => inputHandler(e, 'radio')}
                                    defaultChecked
                                />
                                <Form.Check
                                    type="radio"
                                    label="AGENT"
                                    name="formHorizontalRadios"
                                    id="formHorizontalRadios2"
                                    value="AGENT"
                                    onChange={(e) => inputHandler(e, 'radio')}
                                />
                            </div>

                            <form>
                                <div className={`login-floating-input marginbottom ${login.userName ? 'has-value' : ''}`}>
                                    <input
                                        onChange={(e) => inputHandler(e, 'input')}
                                        value={login.userName}
                                        className="login-input-field"
                                        type="text"
                                        id="agentCode"
                                        name="agentCode"
                                        maxLength="10"
                                    />
                                    <label htmlFor="agentCode" className="login-floating-label">
                                        {inputLabel}
                                    </label>
                                </div>

                                {login.error && (
                                    <div className="login-error">Please Enter {inputLabel}</div>
                                )}

                                <button type="button" onClick={otphandler} className="login-get-otp-btn">
                                    Get OTP
                                </button>
                            </form>
                        </div>
                    )}
                </div>
                </div>
            </div>
        </div>
    )
}

export default Login
